import { useMutation, useQueryClient } from 'react-query';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';
import { ChecklistStep } from '@/types';

interface CompleteChecklistItemPayload {
  completedChecklistItem: ChecklistStep;
}

export const useCompleteChecklistItem = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<void, Error, CompleteChecklistItemPayload>(
    async ({ completedChecklistItem }: CompleteChecklistItemPayload) => {
      const url = new URL(`${APIBaseChronos}/api/user/checklist`);

      await fetch(url.toString(), {
        ...getFetchConfig({ method: FetchMethod.POST }),
        body: JSON.stringify({ completedChecklistItem }),
      });
    },
    {
      onSuccess: () => {
        // Invalidate user query to refresh the checklist items
        queryClient.invalidateQueries([QueryEntity.User]);
      },
    },
  );
};
